import { Link2, Mails, PlayCircle, SendIcon } from 'lucide-react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { VideoLightbox } from '../components';
import SplitButtonDropDown from '../components/SplitButtonDropDown';
import okSvg from '../images/ok.svg';
import { selectSessionAdvisor } from '../model/selectors';
import { useInviteClientTrigger } from '@client/components/invite-client/InviteClientContext';

const DEMO_VIDEO_URL = 'https://www.loom.com/embed/49a4f641f8a44840be0a678bfbf9351e';

export function AdvisorWelcome() {
  const advisor = useSelector(selectSessionAdvisor);
  const { advisorFirstName } = advisor;
  const [showVideoModal, setShowVideoModal] = useState(false);
  const { setInviteClientParams } = useInviteClientTrigger();

  return (
    <div
      id="advisor-welcome-screen"
      data-testid="advisor-welcome-screen"
    >
      <main className="bg-primary-50 my-auto flex h-[calc(100vh)] items-center justify-center">
        <div className="mb-[100px] flex flex-col items-center justify-center">
          <img
            className="text-primary-dark max-w-[378px]"
            src={okSvg}
            alt="welcome"
          />
          <div className="flex -translate-y-10 flex-col items-center justify-center gap-2 md:gap-4">
            <div className="mb-2 md:mb-3">
              <span className="text-primary-dark text-2xl md:text-4xl">{`Welcome, ${advisorFirstName}!`}</span>
            </div>
            <SplitButtonDropDown
              buttonLabel="Invite your first client"
              dropDownItems={[
                {
                  name: 'Send email invite',
                  onClick: () => setInviteClientParams('email'),
                  startIcon: <SendIcon className="h-4 w-4" />,
                },
                {
                  name: 'Intake form link',
                  onClick: () => setInviteClientParams('link'),
                  startIcon: <Link2 className="h-4 w-4" />,
                },
              ]}
              onClick={() => setInviteClientParams()}
              startIcon={<SendIcon className="h-5 w-5" />}
              className="w-68 my-1 h-16 flex-grow justify-center text-xl"
              primaryCta={true}
              testId="invite-client-button-welcome-test"
            />
            <button
              type="button"
              className="flex h-16 w-full items-center justify-center gap-2 rounded-full bg-white px-3 py-2 text-gray-900 ring-1 ring-inset ring-gray-300 transition-colors hover:bg-gray-50 sm:w-[240px] sm:gap-3 sm:px-4 md:w-[282px] md:px-5"
              onClick={() => setShowVideoModal(true)}
              data-testid="welcome-demo-video-button-test"
            >
              <PlayCircle
                className="h-5 w-5 flex-shrink-0 sm:h-6 sm:w-6 md:h-7 md:w-7"
                strokeWidth={1}
              />
              <span className="whitespace-nowrap text-xs font-medium sm:text-sm md:text-base">
                Show me a demo video
              </span>
            </button>
          </div>
        </div>
      </main>
      <VideoLightbox
        videoUrl={`${DEMO_VIDEO_URL}?t=0s`}
        isOpen={showVideoModal}
        onOpenChange={setShowVideoModal}
      />
    </div>
  );
}
